import { createAction } from '@reduxjs/toolkit';

const dirtyBlocksDiscard = createAction('blocks/dirty-blocks-discard');

export { dirtyBlocksDiscard };
